// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__KmDQs","requiredAsterisk":"Info_requiredAsterisk__Y9L6E"};